import {notAllowedInFenceStyle, notAllowedOutFenceStyle} from '../config/globalConfig'
export const drawFence = (fence) => {
  // debugger
  if (fence.type == 'circle') {
    let lat = fence.parameter.points[0][0].lat
    let lng = fence.parameter.points[0][0].lng
    let radius = fence.parameter.radius
    let overlay = new window.BMap.Circle(new window.BMap.Point(lng, lat), radius, fence.opt == 1 ? notAllowedInFenceStyle : notAllowedOutFenceStyle);
    // this.groupFences.push(overlay)
    // this.bmap.addOverlay(overlay)
    return [overlay]
  }
  if (fence.type == 'polygon') {
    let points = []
    fence.parameter.points[0].map( (item) => {
      points.push(new window.BMap.Point(item.lng, item.lat))
    })
    let overlay = new window.BMap.Polygon(points, fence.opt == 1 ? notAllowedInFenceStyle : notAllowedOutFenceStyle);
    // this.groupFences.push(overlay)
    // this.bmap.addOverlay(overlay)
    return [overlay]
  }
  if (fence.type == 'district') {
    let points = []
    let overlays = []
    // fence.parameter.points.forEach((p, index) => {
    //   fence.parameter.points[index].map(function (item) {
    //     points.push(new window.BMap.Point(item.lng, item.lat))
    //   })
    //   let overlay = new window.BMap.Polygon(points, {
    //     strokeColor: fence.opt == 1 ? 'red' : 'green',
    //     strokeWeight: 4,
    //     strokeOpacity: 0.9,
    //     fillOpacity: 0.35
    //   });
    //   // this.groupFences.push(overlay)
    //   // this.bmap.addOverlay(overlay)
    //   overlays.push(overlay)
    // })
    

    for (let i = 0; i < fence.parameter.points.length; i++) {
      // 为解决行政区可能有多个区域，需先定义每个坐标容器 []
      // 当然也可以用 points[i] = [...points[i], new xxxxxxxxx]这样的思路解决问题
      points[i] = []
      for (let j = 0; j < fence.parameter.points[i].length; j++) {
        // debugger
        points[i].push(new window.BMap.Point(fence.parameter.points[i][j].lng, fence.parameter.points[i][j].lat))
      }
      // this.points = [...this.points, ...points[i]]
      overlays.push(new window.BMap.Polygon(points[i], fence.opt == 1 ? notAllowedInFenceStyle : notAllowedOutFenceStyle))
    }
    return overlays
  }
}